import { GRAFANA_API_KEY, GRAFANA_API_URL, GRAFANA_DEFAULT_DATASOURCE, GRAFANA_ORIGIN_DATASOURCE } from 'environment';

class StatsService {

    constructor($http, $q, $log) {
        this.$http = $http;
        this.$q = $q;
        this.$log = $log;
    }

    fetch(params) {
        // Split targets into groups of 14 so as not to exceed the proxy query string limit
        let chunkSize = 14;
        let targetChunks = [];
        for (let i = 0, end = Math.ceil((1.0 * params.targets.length) / chunkSize), asc = 0 <= end; asc ? i < end : i > end; asc ? i++ : i--) {
            targetChunks.push(params.targets.slice(chunkSize * i, chunkSize * (i + 1)));
        }

        // Collect actual params for each set of targets
        let chunkParams = _.map(targetChunks, function(targets) {
            let newParams = { db: 'metrics', epoch: 'ms' };
            newParams.q = _.map(targets, function(e) {
                    let where = `${params.time.join(" AND ")}`;
                    if (params.boxcaster) {
                        where += ` AND boxcaster_id =~ /^${params.boxcaster}$/`;
                    }
                    if (params.stream) {
                        where += ` AND stream_id =~ /^${params.stream}$/`;
                    }
                    if (params.broadcastId) {
                        where += ` AND broadcast_id =~ /^${params.broadcastId}$/`;
                    }
                    if (e.where) { where += ` AND ${e.where}`; }
                    return `SELECT ${e.field} AS \"${e.as}\" FROM \"${e.value}\" WHERE ${where} GROUP BY time(10s) fill(null)`;
                })
                .join(';');
            return _.map(newParams, (v, k) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`).join('&');
        });

        let deferred = this.$q.defer();

        // Collect promises for each request
        let datasource = (params.datasource == 'origin' ? GRAFANA_ORIGIN_DATASOURCE : GRAFANA_DEFAULT_DATASOURCE);
        let promises = _.map(chunkParams, query => this.$http.get(`${GRAFANA_API_URL}/${datasource}/query?${query}`, {
          headers: {'Authorization': 'Bearer ' + GRAFANA_API_KEY}
        }));

        Promise.all(promises).then(function(responses) {
            // Flatten all the results together
            let values = _.map(responses, r => r.data.results).reduce((a, b) => a.concat(b));

            // Map just the values
            values = _.map(values, function(v) {
                if (v.series) {
                    return v.series[0].values;
                } else {
                    return [];
                }
            });

            // Find all the times
            let times = [];
            _.each(values, v =>
                _.each(v, function(e) {
                    let t = e[0] / 1000;
                    return times.push(t);
                })
            );
            times.sort();
            times = _.uniq(times, true);

            // Transform the returned data into a hash with targets as keys and datapoints as key-value pairs with times as keys,
            // filling in any non-existent times with nil values
            let newdata = {};
            _.each(params.targets, function(target, idx) {
                let datapoints = {};
                _.each(values[idx], dataPoint => datapoints[dataPoint[0] / 1000] = dataPoint[1]);
                _.each(times, function(t) {
                    if (!datapoints.hasOwnProperty(t)) { return datapoints[t] = null; }
                });
                return newdata[target.as] = datapoints;
            });
            return deferred.resolve(newdata);
        }, (reason) => {
            deferred.reject(reason);
            return this.$log.error(reason);
        });

        return deferred.promise;
    }
}

angular.module('app.services').service('StatsService', StatsService);



// WEBPACK FOOTER //
// ./services/stats_service.js